import React from "react";

// import { Contact } from "../../blocks/common-contact";
import { Header } from "../../components/Header";

import { PriceBanner } from "../../blocks/price-banner";
import { PriceList } from "../../blocks/price-list";
import { PriceDetail } from "../../blocks/price-detail";
import { PriceQuestion } from "../../blocks/price-question";
import { PriceMessage } from "../../blocks/price-message";

import "./styles.less";
import { Footer } from "../../components/Footer";

export const PricePage = () => {
  return (
    <div className="main-page">
      <Header mode="dark" />
      <PriceBanner />
      <PriceList />
      <PriceMessage />
      <PriceDetail />
      <PriceQuestion />
      <Footer />
    </div>
  );
};
